import { faqWidgetStyles } from "@iewcasia/Widgets/VerndaleBox/FaqWidget";

faqWidgetStyles.title = {
    variant: "h2",
};
